import {Component, OnInit, ViewChild} from "@angular/core";
import {MatTabChangeEvent} from "@angular/material/tabs";

import {PageService} from "src/app/shared/layout/services/page.service";
import {TipoUpload} from "../../shared/importacao-lote/tipo-upload";
import {Observable, Subscription} from "rxjs";
import {ToastService} from "maps-angular-components";
import {
  AssociacaoGrupoCarteiraStepper
} from "../associacao-grupo-carteira-stepper/associacao-grupo-carteira-stepper.component";
import {AssociacaoGrupoCarteiraService} from "../associacao-grupo-carteira.service";
import {ImportacaoLoteComponent} from "../../shared/importacao-lote/importacao-lote.component";
import {Exporter, XLSXExporter} from "../../shared/export/export";
import {HttpResponse} from "@angular/common/http";


@Component({
  selector: "app-associacao-grupo-carteira-tab",
  templateUrl: "./associacao-grupo-carteira-tab.component.html",
  styleUrls: ["./associacao-grupo-carteira-tab.component.scss"],
})
export class AssociacaoGrupoCarteiraTabComponent implements OnInit {
  @ViewChild("associacaoGrupoCarteiraStepper", {static: false}) associacaoGrupoCarteiraStepper: AssociacaoGrupoCarteiraStepper;
  // @ViewChild("associacaoGerenciador", {static: false}) associacaoGerenciador: AssociacaoGerenciadorComponent;
  @ViewChild("associacaoImportacaoLote", {static: false}) associacaoImportacaoLote: ImportacaoLoteComponent;

  private readonly subscriptions = new Subscription();
  readonly tipo: TipoUpload = TipoUpload.ASSOCIACAO_GRUPO_CARTEIRA;

  constructor(private page: PageService,
              private service: AssociacaoGrupoCarteiraService,
              private messageService: ToastService) {
  }

  ngOnInit() {
    this.page.defineTitle("ASSOCIAÇÃO");
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  tabChanged($event: MatTabChangeEvent): void {
    if ($event.index === 0) {
      this.associacaoGrupoCarteiraStepper.limpar();
    }
    // } else if ($event.index === 2) {
    //   this.associacaoGerenciador.limpar();
    // }
  }

  downloadModelo(){
    const exporter = new XLSXExporter();
    this.doExportPage(this.service.downloadModelo(), exporter);
  }

  doExportPage(observableData: Observable<HttpResponse<Blob>>, exporter: Exporter) {
    this.subscriptions.add(observableData.subscribe(
        (data: HttpResponse<Blob>) => exporter.save(data),
        err => this.messageService.erro(err.error.message)
    ));
  }
}
